import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SVGIconModule } from '@progress/kendo-angular-icons';
import { TextBoxModule } from '@progress/kendo-angular-inputs';
import { SVGIcon } from '@progress/kendo-svg-icons';
import { AccountDetailsCardType as CardType } from '../../../shared/constants/account-details-card-type';

@Component({
  selector: 'ntw-account-detail-card',
  templateUrl: './account-detail-card.component.html',
  styleUrls: ['./account-detail-card.component.scss', './../../../shared/styles/button.scss'],
  imports: [
    CommonModule,
    FormsModule,
    SVGIconModule,
    TextBoxModule,
    TranslateModule,
  ]
})
export class AccountDetailCardComponent {
  @Input() title: string = '';
  @Input() icon: SVGIcon | null = null;
  @Input() buttonIcon?: SVGIcon | null = null;
  @Input() type: CardType = CardType.Button;
  @Input() action: () => void = () => { };
  @Input() inputPlaceholder?: string = '';

  @Input() searchValue: string = '';
  @Output() searchValueChange: EventEmitter<string> = new EventEmitter<string>();

  onSearchValueChange(): void {
    this.searchValueChange.emit(this.searchValue);
  }

  onSearch(): void {
    this.action();
  }
}
